import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";

import useAuthContext from "../../providers/authProvider";
import { clubsCount } from "../../services/users";
import Table from "../../components/Table";
import LanguageSwitcher from "../../components/LanguageSwitcher";

const ClubsList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setClub } = useAuthContext();
  const [clubs, setClubs] = useState([]);

  useEffect(() => {
    fetchClubs();
  }, []);

  const fetchClubs = async () => {
    const { clubs } = await clubsCount();
    setClubs(clubs);
  };

  const selectClub = async (clubId) => {
    Cookies.set("club_id", clubId);
    Cookies.remove("organization_id");
    await setClub();
    navigate(`/club_admin/club/${clubId}`);
  };

  return (
    <div className="club-admin">
      <div className="club-admin-navbar">
        <NavBarForClub />
      </div>
      <div className="club-admin-content">
        <div className="teams">
          <div className="teams-header">
            <div className="teams-header-text">{t("clubs.index.title")}</div>
          </div>

          <div className="teams-list">
            <ClubsAll clubs={clubs} selectClub={selectClub} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClubsList;

const ClubsAll = ({ clubs, selectClub }) => {
  const { t } = useTranslation();

  const columns = useMemo(
    () => [
      {
        header: "",
        accessorKey: "logo",
        cell: (info) => (
          <img
            src={info.getValue()}
            alt="logo"
            style={{ width: 32, height: 32 }}
          />
        ),
        meta: { style: { width: 40 } },
      },
      {
        header: t("common.table_name"),
        accessorKey: "name",
        cell: (info) => (
          <div
            onClick={() => selectClub(info.row.original.id)}
          >
            {info.getValue()}
          </div>
        ),
      },
      { header: t("common.teams"), accessorKey: "teams_count" },
      { header: t("common.members"), accessorKey: "members_count" },
      {
        header: t("common.premiums"),
        accessorKey: "premiums",
        cell: (info) => (
          <div className="flex">
            {info.row.original.premiums.map((premium) => (
              <span
                key={premium?.title}
                className="premiums-circle"
                style={{ backgroundColor: "#" + premium?.color }}
              ></span>
            ))}
          </div>
        ),
      },
      {
        id: "actions",
        header: " ",
        cell: (info) => (
          <div className="flex-end ai-center">
            <i
              className="icon icon-login pointer"
              onClick={() => selectClub(info.row.original.id)}
            ></i>
          </div>
        ),
      },
    ],
    []
  );

  return <Table {...{ data: clubs, columns }} />;
};

const NavBarForClub = () => {
  const { t } = useTranslation();
  const { organizations, logout } = useAuthContext();
  const [clubs, setClubs] = useState([]);

  useEffect(() => {
    const getClubs = async () => {
      try {
        const res = await clubsCount();
        setClubs(res.clubs);
      } catch (error) {
        console.error("Failed to fetch clubs:", error);
      }
    };

    getClubs();
  }, []);

  return (
    <div>
      <div className="top-bar">
        <div className="logo">
          <img src="/images/logo.png" alt="logo" />
          Supercoach
        </div>
        <div className="logout">
          {organizations !== 0 && (
            <div className="sidebar-menuitem sidebar-nav">
              <Link to="/club_admin/organization">
                {t("buttons.common.organization")}
              </Link>
            </div>
          )}
          {clubs && (
            <div className="sidebar-menuitem sidebar-nav">
              <Link to="/club_admin/clubs">{t("common.switch-club")}</Link>
            </div>
          )}
          <div className="sidebar-menuitem sidebar-nav">
            <a onClick={logout} href="">
              {t("common.signout")}
            </a>
          </div>
        </div>
      </div>
      <div id="sidebar-wrapper">
        <div className="sidebar-nav active sidebar-menuitem sidebar-label">
          <h4>Select Club</h4>
        </div>
        <LanguageSwitcher />
      </div>
    </div>
  );
};
